var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHairType = function SvgHairType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    strokeWidth: 2,
    d: "M4.922 6.078a.406.406 0 1 0 0-.813.406.406 0 0 0 0 .813z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.406,
    d: "M16.266 12.703V12m0 4.922c-.777 0-1.407-.63-1.407-1.407v-2.812h2.813v2.812c0 .777-.63 1.407-1.406 1.407zM6.328 9.65v5.865a1.406 1.406 0 1 1-2.812 0V9.65"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.406,
    d: "M16.266 16.922c0 3.106-2.566 5.625-5.672 5.625-3.107 0-5.672-2.519-5.672-5.625m11.344-9.141h-2.813V3.562h2.813z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.406,
    d: "M13.453 3.562s-7.125-2.11-8.531-2.11a4.219 4.219 0 1 0 0 8.438c1.406 0 8.531-2.109 8.531-2.109m5.355-4.241a1.635 1.635 0 0 0 2.377.636c.391-.262.705-.389 1.16-.267.456.122.837.435 1.045.858m-4.582 1.585a1.635 1.635 0 0 0 2.377.637c.391-.263.705-.39 1.16-.267.456.122.837.435 1.045.858"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgHairType;